<template>
  <MobileLayout :hideBottomBar="true">
    <MobileHeader :logoColor="'black'" />
    <section class="m-hero font-apercu-medium">
      <img :src="heroImage" alt="Contact" class="m-hero-image" />
      <div class="m-hero-overlay">
        <div class="m-hero-title">TEMPORARY SITE</div>
        <div class="m-hero-sub">
          <p>You can find us through the information below.</p>
          <p>Our new website is coming soon.</p>
        </div>
      </div>
    </section>

    <!-- Footer 内容直接嵌入 -->
    <footer class="m-footer" style="margin-top: 34rem; padding-bottom: 0;">
      <div class="m-footer-grid m-footer-grid-contact">
        <div class="m-footer-left">
           
          <div class="m-footer-title m-footer-right-style">GENERAL ENQUIRES</div>
          <div class="m-footer-desc" style="margin-top: 10rem;">
            <div class="m-footer-link">{{ companyEmail }}</div>
            <div class="m-footer-link" style="text-decoration: none;">{{ companyPhone }}</div>
          </div>

          <div class="m-footer-title m-footer-title-gap">INSTAGRAM</div>
          <div class="m-footer-desc" style="margin-top: 10rem;">
            <div class="m-footer-link" style="text-decoration: none;">
              <a href="https://www.instagram.com/den_holm/" target="_blank" class="contact-link" style="display: block; text-decoration: none;">{{ instagram1 }}</a>
            </div>
            <div class="m-footer-link" style="text-decoration: none;">
              <a href="https://www.instagram.com/den_holmunited/" target="_blank" class="contact-link" style="display: block; text-decoration: none;">{{ instagram2 }}</a>
            </div>
          </div>

          <div class="m-footer-title m-footer-title-gap">STUDIO</div>
          <div class="m-footer-desc" style="margin-top: 10rem; max-width: 150rem;">
            {{ companyAddress }}
          </div>
        </div>

        <div class="m-footer-right">
          <img :src="textImg" alt="denHolm" class="m-footer-text-img" />
        </div>
      </div>
    </footer>
  </MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import MobileHeader from '@/components/mobile/header.vue'
import { getSiteConfig, subscribeEmail } from '@/api/content'

const heroImage = require('@/assets/contact/contact1.png')
const textImg = require('@/assets/mobile/contact/textFull.png')

export default {
  name: 'MobileContact',
  components: {
    MobileLayout,
    MobileHeader
  },
  data() {
    return {
      heroImage,
      textImg,
      email: '',
      submitting: false,
      message: '',
      messageType: '',
      companyEmail: 'info@den-holm.com',
      companyPhone: '+61 422 875 261',
      companyAddress: '12 Fulton Street, Oakleigh South 3167 Victoria, Australia',
      instagram1: '@den_holm',
      instagram2: '@den_holmunited'
    }
  },
  mounted() {
    this.loadSiteConfig()
  },
  methods: {
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    async handleSubmit() {
      this.message = ''
      if (!this.email) {
        this.showMessage('Please enter your email address.', 'error')
        return
      }
      if (!this.isValidEmail(this.email)) {
        this.showMessage('Please enter a valid email address.', 'error')
        return
      }
      if (this.submitting) return
      this.submitting = true

      try {
        const response = await subscribeEmail(this.email)
        console.log(response)
        if (response && response.retCode === 1) {
          this.showMessage('Subscription successful! Thank you.', 'success')
          this.email = ''
        } else {
          this.showMessage('Subscription failed. Please try again.', 'error')
        }
      } catch (error) {
        console.error('Subscription error:', error)
        this.showMessage('An error occurred. Please try again.', 'error')
      } finally {
        this.submitting = false
      }
    },
    showMessage(msg, type) {
      this.message = msg
      this.messageType = type
      setTimeout(() => {
        this.message = ''
      }, 3000)
    },
    async loadSiteConfig() {
      try {
        const response = await getSiteConfig()
        const config = response.result
        if (config) {
          this.companyEmail = config.CompanyEmail || this.companyEmail
          this.companyPhone = config.CompanyPhone || this.companyPhone
          this.companyAddress = config.CompanyAddress || this.companyAddress
          this.instagram1 = config.Instagram1 || this.instagram1
          this.instagram2 = config.Instagram2 || this.instagram2
        }
        console.log(this.companyAddress)
      } catch (error) {
        console.error('Failed to load site config:', error)
      }
    }
  }
}
</script>

<style scoped>
.m-hero {
  position: relative;
}

.m-hero-image {
  width: 100%;
  height: 358rem;
  object-fit: cover;
}

.m-hero-overlay {
  position: absolute;
  bottom: 40rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20rem;
  color: #fff;
  text-shadow: 0 2rem 10rem rgba(0, 0, 0, 0.45);
  width: 90%;
}

.m-hero-title {
  font-size: 14rem;
  font-weight: 500;
}

.m-hero-sub {
  font-size: 10rem;
  width: 80%;
  font-weight: 500;
  text-align: center;
}

.m-hero-sub p {
  margin: 0;
}

/* Footer 样式 */
.m-footer {
  padding: 18rem 25rem 30rem;
  background: #fff;
  color: #000;
  font-family: 'Apercu-Medium', sans-serif;
}

.m-footer-grid {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.m-footer-grid-contact {
  border-top: none;
}

.m-footer-title {
  font-size: 10rem;
  font-weight: 700;
  letter-spacing: 0.3rem;
}

.m-footer-title-gap {
  margin-top: 42rem;
}

.m-footer-desc {
  font-size: 8rem;
  margin-top: 30rem;
}

.m-footer-field {
  margin-top: 30rem;
}

.m-footer-underline {
  margin-top: 6rem;
  height: 1rem;
  background: #000;
  width: 90%;
}

.contact-link {
  color: #000;
}

.m-footer-link {
  text-decoration: underline;
  text-underline-offset: 2rem;
  margin-top: 4rem;
}

.m-footer-right {
  display: flex;
  flex-direction: column;
   width: 50%;
}

.m-footer-left {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.m-footer-right-style {
  display: flex;
  justify-content: flex-start;
}

.m-footer-input {
  font-size: 8rem;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  color: #000;
  font-family: 'Apercu-Medium', sans-serif;
}

.m-footer-input::placeholder {
  color: #000;
}

.m-footer-text-img {
  width: 40%;
  height: auto;
  position: fixed;
  right: 10rem;
}

.m-footer-message {
  font-size: 8rem;
  margin-top: 8rem;
}

.m-footer-message.success {
  color: green;
}

.m-footer-message.error {
  color: red;
}
</style>